import React from 'react';

const AddAulaButton = ({ openAddAulaModal }) => {
  return (
    <div className="col-12 col-xl-3 col-md-6 py-1">
      <button 
        type="button" 
        className="d-flex align-items-center justify-content-center btn btn-primary text-white w-100 fw-semibold"
        onClick={openAddAulaModal}
      >
        <i className="bi bi-plus fs-4"></i> Aula/Módulo
      </button>
    </div>
  );
};

export default AddAulaButton; 